// Shared Clerk appearance — keeps SignIn/SignUp visually on-brand (sky/white).
export const clerkAppearance = {
  layout: {
    socialButtonsPlacement: "top",
    socialButtonsVariant: "blockButton",
    showOptionalFields: true,
  },
  variables: {
    colorPrimary: "#0ea5e9",
    colorText: "#0f172a",
    colorTextSecondary: "#64748b",
    colorBackground: "#ffffff",
    colorInputBackground: "#f8fafc",
    colorInputText: "#0f172a",
    borderRadius: "0.85rem",
    fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
    fontSize: "0.95rem",
  },
  elements: {
    rootBox: "w-full",
    cardBox: "w-full shadow-xl shadow-sky-100/60 rounded-2xl border border-slate-100",
    card: "bg-white rounded-2xl px-7 py-8 gap-5",
    header: "gap-1",
    headerTitle: "font-display text-2xl font-extrabold text-slate-900",
    headerSubtitle: "text-slate-500",
    socialButtonsBlockButton:
      "border border-slate-200 rounded-xl hover:border-sky-300 hover:bg-slate-50 transition",
    socialButtonsBlockButtonText: "font-semibold text-slate-700",
    dividerLine: "bg-slate-200",
    dividerText: "text-slate-400 text-xs",
    formFieldLabel: "text-slate-600 font-medium",
    formFieldInput:
      "bg-slate-50 border border-slate-200 rounded-xl focus:border-sky-400 focus:ring-2 focus:ring-sky-100 transition",
    formButtonPrimary:
      "bg-sky-500 hover:bg-sky-600 active:bg-sky-700 text-sm font-semibold normal-case rounded-xl shadow-md shadow-sky-200 transition",
    footerActionText: "text-slate-500",
    footerActionLink: "text-sky-600 hover:text-sky-700 font-semibold",
    identityPreviewEditButton: "text-sky-600",
    formResendCodeLink: "text-sky-600 font-semibold",
    otpCodeFieldInput: "border-slate-200 focus:border-sky-400",
  },
};

export default clerkAppearance;
